<template>
    <Carousel v-bind="config">
        <slot />

        <template #addons>
            <Navigation />
            <Pagination />
        </template>
    </Carousel>
</template>

<script setup>
// If you are using PurgeCSS, make sure to whitelist the carousel CSS classes
import 'vue3-carousel/carousel.css'
import { Carousel, Pagination, Navigation } from 'vue3-carousel'

defineProps({
    config: {
        type: Object,
        required: false,
        default: () => ({})
    }
})
</script>
